import React, { useState } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import contactImg from '../assets/LINK-Fotografie-1806_47909.jpg';
import './Contact.css';

const initialForm = {
  name: '',
  email: '',
  subject: '',
  message: ''
};

const Contact = () => {
  const [form, setForm] = useState(initialForm);
  const [status, setStatus] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // No dedicated backend contact endpoint yet. We keep UX smooth and fallback to mail action.
    window.location.href = `mailto:info.suriname@nlba.com?subject=${encodeURIComponent(form.subject)}&body=${encodeURIComponent(
      `Naam: ${form.name}\nEmail: ${form.email}\n\n${form.message}`
    )}`;
    setStatus('success');
    setForm(initialForm);
  };

  return (
    <div className="contact-page">
      <Navbar />
      <section className="contact-section">
        <div className="contact-container">
          <h1 className="contact-title">Contact</h1>
          <p className="contact-subtitle">Neem gerust contact met ons op. We reageren zo snel mogelijk.</p>

          <div className="contact-grid">
            <form className="contact-form" onSubmit={handleSubmit} noValidate>
              <div className="contact-field">
                <label htmlFor="name">Naam</label>
                <input
                  id="name"
                  name="name"
                  type="text"
                  value={form.name}
                  onChange={handleChange}
                  required
                  placeholder="Uw volledige naam"
                />
              </div>

              <div className="contact-field">
                <label htmlFor="email">E-mailadres</label>
                <input
                  id="email"
                  name="email"
                  type="email"
                  value={form.email}
                  onChange={handleChange}
                  required
                  placeholder="uw@email.com"
                />
              </div>

              <div className="contact-field">
                <label htmlFor="subject">Onderwerp</label>
                <input
                  id="subject"
                  name="subject"
                  type="text"
                  value={form.subject}
                  onChange={handleChange}
                  required
                  placeholder="Onderwerp van uw bericht"
                />
              </div>

              <div className="contact-field">
                <label htmlFor="message">Bericht</label>
                <textarea
                  id="message"
                  name="message"
                  rows={6}
                  value={form.message}
                  onChange={handleChange}
                  required
                  placeholder="Schrijf hier uw bericht..."
                />
              </div>

              {status === 'success' && (
                <p className="contact-feedback contact-feedback-success">
                  Uw e-mailclient is geopend. Uw bericht is klaar om te verzenden.
                </p>
              )}

              <button className="btn-primary" type="submit">Verstuur bericht</button>
            </form>

            <aside className="contact-info">
              <h2>NLBA Suriname</h2>
              <p>Paramaribo, Suriname</p>
              <p><strong>E-mail:</strong> <a href="mailto:info.suriname@nlba.com">info.suriname@nlba.com</a></p>
              <p><strong>Tel:</strong> <a href="tel:+597472114">+597 472114</a></p>
              <p><strong>Mobiel:</strong> <a href="tel:+5978501652">+597 8501652</a></p>
              <img src={contactImg} alt="NLBA contact" className="contact-image" loading="lazy" />
            </aside>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Contact;
